<template>
	<v-card>
		<v-card-title>
			<h3>Filtri</h3>
		</v-card-title>
		<v-divider />
		<v-card-text>
			<h2 class="subtitle-1 primary--text mb-2">Range Temporale</h2>

			<v-row>
				<v-col class="d-flex justify-space-between flex-wrap">
					<v-btn class="my-2" color="primary" @click="setRange('month')">Mese</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('quarter')">Trimestre</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('year')">Anno</v-btn>
					<v-btn class="my-2" color="primary" @click="setRange('all')">Tutte</v-btn>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" sm="6">
					<v-menu
						ref="fromMenu"
						v-model="fromMenu"
						:close-on-content-click="true"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field v-model="from" label="Dal giorno" readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="from" no-title scrollable actions locale="it-IT">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">OK</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>

				<v-col cols="12" sm="6">
					<v-menu
						ref="toMenu"
						v-model="toMenu"
						:close-on-content-click="true"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field v-model="to" label="Al giorno" readonly v-on="on"></v-text-field>
						</template>
						<v-date-picker v-model="to" no-title scrollable actions locale="it-IT">
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">OK</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<h2 class="subtitle-1 primary--text my-2">Generali</h2>

			<v-row>
				<v-col cols="12" md="4" xl="12">
					<v-select :items="typologies" v-model="kind" label="Categoria"></v-select>
				</v-col>

				<v-col cols="12" md="4" xl="12">
					<v-select :items="payments" v-model="payment" label="Pagamento"></v-select>
				</v-col>

				<v-col cols="12" md="4" xl="12">
					<v-select :items="users" v-model="user" label="Utente"></v-select>
				</v-col>
			</v-row>

			<h2 class="subtitle-1 primary--text mt-2">Flags</h2>

			<v-row class="flex flex-row flex-wrap">
				<v-col class="py-0">
					<v-checkbox v-model="invoice" indeterminate label="Fattura"></v-checkbox>
				</v-col>

				<v-col class="py-0">
					<v-checkbox v-model="b2b" indeterminate label="B2B"></v-checkbox>
				</v-col>

				<v-col class="py-0">
					<v-checkbox v-model="gift" indeterminate label="Omaggio"></v-checkbox>
				</v-col>

				<v-col class="py-0">
					<v-checkbox v-model="coffee" indeterminate label="Caffè"></v-checkbox>
				</v-col>

				<v-col class="py-0">
					<v-checkbox v-model="points_sh" indeterminate label="Punti SH"></v-checkbox>
				</v-col>
			</v-row>
		</v-card-text>
		<v-divider />
		<v-card-actions class="pa-3">
			<v-btn color="orange" class="ml-auto white--text" @click="RESET_FILTRI_STORICO_VENDITE">
				Reset Filtri
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
	name: 'Filters',

	data() {
		return {
			fromMenu: false,
			toMenu: false,
		}
	},

	props: {
		operations: { kind: Array, default: () => [] },
	},

	methods: {
		...mapMutations([
			'SET_FILTRI_STORICO_VENDITE_FROM',
			'SET_FILTRI_STORICO_VENDITE_TO',
			'SET_FILTRI_STORICO_VENDITE_KIND',
			'SET_FILTRI_STORICO_VENDITE_PAYMENT',
			'SET_FILTRI_STORICO_VENDITE_USER',
			'SET_FILTRI_STORICO_VENDITE_INVOICE',
			'SET_FILTRI_STORICO_VENDITE_B2B',
			'SET_FILTRI_STORICO_VENDITE_COFFEE',
			'SET_FILTRI_STORICO_VENDITE_GIFT',
			'SET_FILTRI_STORICO_VENDITE_POINTS_SH',

			'RESET_FILTRI_STORICO_VENDITE',
		]),

		setRange(mode) {
			const date = new Date()
			let firstDay, lastDay

			switch (mode) {
				case 'month':
					firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'quarter':
					firstDay = new Date(date.getFullYear(), date.getMonth() - 2, 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'year':
					firstDay = new Date(date.getFullYear(), 0, 1)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				case 'all':
					firstDay = new Date(2019, 8, 14)
					lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

					break
				default:
					break
			}

			this.SET_FILTRI_STORICO_VENDITE_FROM(this.formatDate(firstDay))
			this.SET_FILTRI_STORICO_VENDITE_TO(this.formatDate(lastDay))
		},

		formatDate(date) {
			var d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear()

			if (month.length < 2) month = '0' + month
			if (day.length < 2) day = '0' + day

			return [year, month, day].join('-')
		},
	},

	computed: {
		...mapGetters(['getFiltriStoricoVendite']),
		//Vuex
		from: {
			get() {
				return this.getFiltriStoricoVendite.from
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_FROM(value)
			},
		},
		to: {
			get() {
				return this.getFiltriStoricoVendite.to
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_TO(value)
			},
		},
		kind: {
			get() {
				return this.getFiltriStoricoVendite.kind
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_KIND(value)
			},
		},
		payment: {
			get() {
				return this.getFiltriStoricoVendite.payment
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_PAYMENT(value)
			},
		},
		user: {
			get() {
				return this.getFiltriStoricoVendite.user
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_USER(value)
			},
		},
		invoice: {
			get() {
				return this.getFiltriStoricoVendite.invoice
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_INVOICE(value)
			},
		},
		b2b: {
			get() {
				return this.getFiltriStoricoVendite.b2b
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_B2B(value)
			},
		},
		coffee: {
			get() {
				return this.getFiltriStoricoVendite.coffee
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_COFFEE(value)
			},
		},
		gift: {
			get() {
				return this.getFiltriStoricoVendite.gift
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_GIFT(value)
			},
		},
		points_sh: {
			get() {
				return this.getFiltriStoricoVendite.points_sh
			},
			set(value) {
				this.SET_FILTRI_STORICO_VENDITE_POINTS_SH(value)
			},
		},
		// Utilities
		typologies() {
			let typologies = []

			this.operations.map((el) => {
				const exist = typologies.find((el) => el === el.kind)

				if (!exist) {
					typologies.push(el.kind)
				}
			})

			typologies.sort()
			typologies.unshift('Tutte')

			return typologies
		},
		payments() {
			let payments = []

			this.operations.map((el) => {
				const exist = payments.find((el) => el === el.payment_method)

				if (!exist) {
					payments.push(el.payment_method)
				}
			})

			payments.sort()
			payments.unshift('Tutti')

			return payments
		},
		users() {
			let users = []

			this.operations.map((el) => {
				const exist = users.find((el) => el === el.user)

				if (!exist) {
					users.push(el.user)
				}
			})

			users.sort()
			users.unshift('Tutti')

			return users
		},
	},
}
</script>
